import { render, staticRenderFns } from "./bloodGlucoseMonitor.vue?vue&type=template&id=5923cfee&scoped=true"
import script from "./bloodGlucoseMonitor.vue?vue&type=script&lang=js"
export * from "./bloodGlucoseMonitor.vue?vue&type=script&lang=js"
import style0 from "./bloodGlucoseMonitor.vue?vue&type=style&index=0&id=5923cfee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5923cfee",
  null
  
)

export default component.exports